import { AirQualityProvider } from '../providers/airQualityProvider';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_CURRENT_AIR_QUALITY_BY_LATLON = 'GET_CURRENT_AIR_QUALITY_BY_LATLON';
export const GET_CURRENT_AIR_QUALITY_BY_LATLON_PENDING = 'GET_CURRENT_AIR_QUALITY_BY_LATLON_PENDING';
export const GET_CURRENT_AIR_QUALITY_BY_LATLON_FULFILLED = 'GET_CURRENT_AIR_QUALITY_BY_LATLON_FULFILLED';
export const GET_CURRENT_AIR_QUALITY_BY_LATLON_REJECTED = 'GET_CURRENT_AIR_QUALITY_BY_LATLON_REJECTED';
export const GET_AIR_QUALITY_FORECAST_BY_LATLON = 'GET_AIR_QUALITY_FORECAST_BY_LATLON';
export const GET_AIR_QUALITY_FORECAST_BY_LATLON_PENDING = 'GET_AIR_QUALITY_FORECAST_BY_LATLON_PENDING';
export const GET_AIR_QUALITY_FORECAST_BY_LATLON_FULFILLED = 'GET_AIR_QUALITY_FORECAST_BY_LATLON_FULFILLED';
export const GET_AIR_QUALITY_FORECAST_BY_LATLON_REJECTED = 'GET_AIR_QUALITY_FORECAST_BY_LATLON_REJECTED';
export const REFRESH_CURRENT_AIR_QUALITY_BY_LATLON = 'REFRESH_CURRENT_AIR_QUALITY_BY_LATLON';
export const REFRESH_CURRENT_AIR_QUALITY_BY_LATLON_PENDING = 'REFRESH_CURRENT_AIR_QUALITY_BY_LATLON_PENDING';
export const REFRESH_CURRENT_AIR_QUALITY_BY_LATLON_FULFILLED = 'REFRESH_CURRENT_AIR_QUALITY_BY_LATLON_FULFILLED';
export const REFRESH_CURRENT_AIR_QUALITY_BY_LATLON_REJECTED = 'REFRESH_CURRENT_AIR_QUALITY_BY_LATLON_REJECTED';
export const REFRESH_AIR_QUALITY_FORECAST_BY_LATLON = 'REFRESH_AIR_QUALITY_FORECAST_BY_LATLON';
export const REFRESH_AIR_QUALITY_FORECAST_BY_LATLON_PENDING = 'REFRESH_AIR_QUALITY_FORECAST_BY_LATLON_PENDING';
export const REFRESH_AIR_QUALITY_FORECAST_BY_LATLON_FULFILLED = 'REFRESH_AIR_QUALITY_FORECAST_BY_LATLON_FULFILLED';
export const REFRESH_AIR_QUALITY_FORECAST_BY_LATLON_REJECTED = 'REFRESH_AIR_QUALITY_FORECAST_BY_LATLON_REJECTED';

export function getCurrentAirQualityByLatLon(...params) {

    let paramsObject = {
        latitude: undefined,
        longitude: undefined,
        isCached: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        verbose: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject);

    return {
        type: GET_CURRENT_AIR_QUALITY_BY_LATLON,
        payload: getCurrentAirQuality(paramsObject)
    };
}

export function getAirQualityForecastByLatLon(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, useCache) {
    return {
        type: GET_AIR_QUALITY_FORECAST_BY_LATLON,
        payload: getAirQualityForecast(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, useCache)
    };
}

export function refreshCurrentAirQualityByLatLon(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose) {
    return {
        type: REFRESH_CURRENT_AIR_QUALITY_BY_LATLON,
        payload: refreshCurrentAirQuality(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose)
    };
}

export function refreshAirQualityForecastByLatLon(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, useCache) {
    return {
        type: REFRESH_AIR_QUALITY_FORECAST_BY_LATLON,
        payload: refreshAirQualityForecast(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, useCache)
    };
}

async function getCurrentAirQuality({ latitude, longitude, isCached, baseUrl, authId, secret, stdParameters, verbose }) {
    const op = new AirQualityProvider(baseUrl, authId, secret);
    return await op.getCurrentAirQuality(latitude, longitude, isCached, stdParameters, verbose);
}

async function getAirQualityForecast(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, useCache) {
    const op = new AirQualityProvider(baseUrl, authId, secret);
    return await op.getAirQualityForecast(latitude, longitude, stdParameters, verbose, useCache);
}

async function refreshCurrentAirQuality(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose) {
    const op = new AirQualityProvider(baseUrl, authId, secret);
    return await op.refreshCurrentAirQuality(latitude, longitude, stdParameters, verbose);
}

async function refreshAirQualityForecast(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose, useCache) {
    const op = new AirQualityProvider(baseUrl, authId, secret);
    return await op.refreshAirQualityForecast(latitude, longitude, stdParameters, verbose, useCache);
}
